import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { isAPIError } from '@/store/utils';

// eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- void
export const confirmEmailThunk = createAppAsyncThunk<void, { code: string }>(
  'auth/confirmEmail',
  async(params, { extra: { authService }, rejectWithValue }) => {
    try {
      await authService.confirmEmail(params);
    } catch (error) {
      if (isAPIError(error) && error.fieldErrors != null) {
        return rejectWithValue({ fieldErrors: error.fieldErrors });
      }
      throw error;
    }
  }
);
